import React from 'react'
import MotorItemContainer from './MotorItemContainer'
import { motorShape } from '../../shapes'

const MotorItem = props => <MotorItemContainer {...props} />

MotorItem.propTypes = {
  motor: motorShape.isRequired
}

export default MotorItem
